const ENABLE = true

export function analyseDataLoaded (loadedData) {
  if (!ENABLE) return

  console.group('analyseDataLoaded')

  console.log('loadedData', loadedData)

  confirmZenflowAccounts(loadedData)
  analyseDates(loadedData)
  showSpecialValues(loadedData)

  console.groupEnd()
}

function showSpecialValues (loadedData) {
  const zenflowCoa = loadedData.convertedValuesResults.chartOfAccounts.filter(function (coa) {
    return coa.is_zenflow
  })

  const specialValues = loadedData.convertedValuesResults.convertedValues.filter(function (cv) {
    return zenflowCoa.some(function (coa) {
      return coa.id === cv.accounting_chart_of_account_id
    })
  })

  console.group('specialValues')
  console.log('specialValues', specialValues)

  const specialValuesCoas = specialValues.map(function (cv) {
    return cv.accounting_chart_of_account_id
  })
  console.log('specialValuesCoas', new Set(specialValuesCoas))

  console.groupEnd()
}

function analyseDates (loadedData) {
  const receivedDates = loadedData.convertedValuesResults.convertedValues.map(function (cv) {
    return cv.month
  })

  const receivedDatesSet = new Set(receivedDates)

  console.log('receivedDatesSet', receivedDatesSet)
}

function confirmZenflowAccounts (loadedData) {
  const zenflowCoa = loadedData.convertedValuesResults.chartOfAccounts.filter(function (coa) {
    return coa.is_zenflow
  })

  console.log('zenflowCoa', zenflowCoa)
}
